import fetch from '@/util/http'

export default {
  activityPage(params) {
    return fetch.get('activity/page', params)
  },
  activityGet(params) {
    return fetch.get('activity/get', params)
  },
  activityCancel(model) {
    return fetch.post('activitySignTemp/cancel', model)
  },
  activitySignMembersList(params) {
    return fetch.get('activitySign/signMembers', params)
  },
  activitySave(model) {
    return fetch.json('activitySignTemp/sign', model)
  },
  activitySignNum() {
    return fetch.get('my/activityNum')
  },
  activityJoinSuccessImg() {
    return fetch.get('config/activity_sign_success')
  },
  activityGetSpecialquestion(params) {
    return fetch.get('spcialquestion/trun', params)
  },
  activitySaveSpecialquestion(params) {
    return fetch.json('spcialquestion/answer', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/activity.js